import { createI18n } from 'vue-i18n'
import set from 'lodash-es/set'
import en from './locales/en';
import pt from './locales/pt';
import data from './data.json';

data.forEach(item => {
  set(en, item.key, item.val.en)
  set(pt, item.key, item.val.pt)
})

const options = {
  messages: {
    en,
    pt,
  },
  locale: 'pt',
  // fallbackLng: 'en',
  fallbackLocale: 'en',
  interpolation: {
    escapeValue: false // 不需要转义特殊字符
  }
};

export default createI18n(options);
